import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the PropertyDocumentChecklistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-property-document-checklist',
  templateUrl: 'property-document-checklist.html',
})
export class PropertyDocumentChecklistPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PropertyDocumentChecklistPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/property-document-checklist/property-document-checklist.ts